module.exports = __webpack_public_path__ + "images/FUSA_icons/077-shopping-bag.56b0118a48c16ecfaa1aea9f3e2638ea.svg";